import { render, staticRenderFns } from "./PhoneSVG.vue?vue&type=template&id=4dee7b65&scoped=true&"
import script from "./PhoneSVG.vue?vue&type=script&lang=js&"
export * from "./PhoneSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dee7b65",
  null
  
)

export default component.exports